import { Pagination } from "@/components";
import { useDesignMaxTheme } from "@/packages";
import { useNewNavigate } from "@/shared/client";
import { type RoomDMaxInfoResponse } from "@/shared/server";
import { FONT } from "@/styles";
import { Button, Center, Flex, Spinner, Text } from "@chakra-ui/react";
import { useState } from "react";
import { RoomDetail, RoomImgSlide } from "./components";

export const RoomPreview = ({ data }: { data: RoomDMaxInfoResponse }) => {
    const { onNavigate } = useNewNavigate();
    // const { ref, inView } = useInView({ threshold: 0.9, delay: 0.3, triggerOnce: true });
    const [currentIdx, setCurrentIdx] = useState(0);
    const { MEDIAS } = useDesignMaxTheme();
    const { isMobile } = MEDIAS();

    const nextSlide = () => {
        if (data) setCurrentIdx((prev) => (prev === (data.rooms.length as number) - 1 ? 0 : prev + 1));
    };
    const prevSlide = () => {
        if (data) setCurrentIdx((prev) => (prev === 0 ? (data.rooms.length as number) - 1 : prev - 1));
    };

    return data ? (
        <Center position="relative" width="100%" background="#fbf6f2">
            <Center
                as="section"
                borderTopLeftRadius={isMobile ? "40px" : "88px"}
                borderBottomRightRadius={isMobile ? "40px" : "88px"}
                p={isMobile ? "8px 0 24px 0" : "120px 0"}
                background="#fff"
                flexDir={isMobile ? "column" : "row"}
            >
                <RoomImgSlide rooms={data.rooms} currentIdx={currentIdx} />
                <Flex
                    position="relative"
                    maxW="896px"
                    minHeight={isMobile ? "362PX" : "970px"}
                    w="100%"
                    h="100%"
                    p={isMobile ? "24px 16px 0 16px" : "120px 80px 0 80px"}
                    flexDir="column"
                >
                    <RoomDetail rooms={data.rooms} currentIdx={currentIdx} />
                    <Flex justifyContent={isMobile ? "space-between" : "normal"}>
                        {isMobile && (
                            <Button
                                p="0 24px"
                                h="40px"
                                background="none"
                                border="1px solid #6b6b6b"
                                borderRadius="20px"
                                color="#6b6b6b"
                                {...FONT("notoSerif", 14, 400, 1.4)}
                                onClick={() => onNavigate({ path: `/rooms/${data.rooms[currentIdx].room_idx}` })}
                            >
                                MoreView
                            </Button>
                        )}
                        <Pagination
                            showPage={!isMobile ?? true}
                            currentPage={currentIdx}
                            totalPages={data.rooms.length}
                            nextPage={nextSlide}
                            prevPage={prevSlide}
                            colorMode="black"
                        />
                    </Flex>
                </Flex>
            </Center>
        </Center>
    ) : (
        <Center h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
